module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_reason05-456fddcb7d2aa4d6e9cf70d53b5569b7.png";